import React from 'react';
import {Paper,} from '@material-ui/core';
import ContentArea from "../../../organisms/content-area/ContentArea";

export default function SocialNetwork() {
  return (
    <ContentArea>
      <div style={{marginTop:'2em'}}>
        <h1>Social Network</h1>
      </div>
      {/*<InProgress />*/}
      <Paper style={{marginTop:'1em', padding: '1em', maxWidth: 'fit-content'}}>
        <div id="underConstruction">
          This section of the website is under development.
          <br/>
          We apologize for any inconvenience.
        </div>
      </Paper>
    </ContentArea>
  );
}
